// Emp1.jsx
import React, { useState } from 'react';
import ABTextEdu from '../../Common/ABTextEdu';
// import ABMonthYear from '../../Common/ABMonthYear';
import RadioButtonGroup from '../../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup';
import EMPDate from '../../EmploymentForm/empDate';
import QualificationDropdown from '../../DiyDigilockerNonIBridge/Dropdown';
import Checkbox from '../../../UI_Design/FormComponents/CheckboxAndLabel/Checkbox';

const Emp1 = ({ caseCheckId, fields, index, textHandler, allDisabled, otherInstituteObj }) => {
  const [isContactRM, setIsContactRM] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const saveDateHandler = (checkDetailsIndex, fieldName, date) => {
    console.log(`Date saved: ${date}`);
    // Implement your date saving logic here
  };

  const handleDropdownChange = (event) => {
    console.log(`Selected value: ${event.target.value}`);
    // Implement your dropdown change logic here
  };

  const handleRadioButtonChange = (index) => {
    setIsContactRM(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangePFS1952 = (index) => {
    // setIsContactRM(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangeEPS1995 = (index) => {
    // setIsContactRM(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangeEPFSorEPS = (index) => {
    // setIsContactRM(index === 0); // Assuming "Yes" is the first option
  };

  const handleCheckboxChange = (checked) => {
    setIsChecked(checked);
    console.log('Checkbox is now:', checked);
  };

  return (
    <div className='py-3'>
      <h1 className='tabsContentHead'>Employment 1  : Previous employment</h1>
      <p className='tabsContentSubHead'>
        Enter Your Most Recent Employment Details.
      </p>

      <div className="initialDetails border-bottom my-3">
        <h1 className='tabsContentHead pt-3'>Company Details</h1>
        <div className="row">
          <ABTextEdu
            label="Company Name"
            name="CompanyName"
            id="CompanyName"
            fieldId="CompanyNameField"
            isRequired={1}
            errId="CompanyNameError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="CompanyName"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Company Email"
            name="CompanyEmail"
            id="CompanyEmail"
            fieldId="CompanyEmailField"
            isRequired={1}
            errId="CompanyEmailError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="CompanyEmail"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Complete Address of Company"
            name="CompleteAddressOfCompany"
            id="CompleteAddressOfCompany"
            fieldId="CompleteAddressOfCompanyField"
            isRequired={1}
            errId="CompleteAddressOfCompanyError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="CompleteAddressOfCompany"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="City (Location)"
            name="CityLocation"
            id="CityLocation"
            fieldId="CityLocationField"
            isRequired={1}
            errId="CityLocationError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="CityLocation"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="Employment Type"
              labelStyle={{ color: '#6B7280' }}
              options={["Full Time", "Part Time", "Contractual", "Freelance", "Third-Party", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="Salary Cycle"
              labelStyle={{ color: '#6B7280' }}
              options={["15-Days", "Monthly", "Quatorly", "Half-Yearly", "Annually", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
          <EMPDate
            placeholder="Date of joining"
            name="dateOfJoining"
            id="dateOfJoining"
            fieldId="dateOfJoiningField"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="company_date_joining"
            errId="dateOfJoiningError"
            isRequired={1}
            saveDate={saveDateHandler}
            isDisabled={allDisabled}
            checkID={58} // Example checkID, adjust according to your logic
            minDateDOL={null}
            maxDOJDate={null}
            divClass="col-lg-4 col-md-6 col-sm-12"
            placeholderStyle={{ color: '#6B7280' }}
          />
          <EMPDate
            placeholder="Date of Exit"
            name="dateOfExit"
            id="dateOfExit"
            fieldId="dateOfExitField"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="company_date_Exit"
            errId="dateOfExitError"
            isRequired={1}
            saveDate={saveDateHandler}
            isDisabled={allDisabled}
            checkID={58} // Example checkID, adjust according to your logic
            minDateDOL={null}
            maxDOJDate={null}
            divClass="col-lg-4 col-md-6 col-sm-12"
            placeholderStyle={{ color: '#6B7280' }}
          />
          <div className="col-lg-4 col-md-6 col-sm-12">
            <Checkbox
              label="Working till now"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
          </div>
        </div>
      </div>

      <div className="kycDetails border-bottom my-3">
        <h1 className='tabsContentHead pt-3'>Job/Role Details</h1>
        <div className="row">
          <ABTextEdu
            label="Salary CTC"
            name="SalaryCTC"
            id="SalaryCTC"
            fieldId="SalaryCTCField"
            isRequired={1}
            errId="SalaryCTCError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="SalaryCTC"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Designation"
            name="Designation"
            id="Designation"
            fieldId="DesignationField"
            isRequired={1}
            errId="DesignationError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="Designation"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Department"
            name="Department"
            id="Department"
            fieldId="DepartmentField"
            isRequired={1}
            errId="DepartmentError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="Department"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Role & Responsibilties"
            name="RoleResponsibilties"
            id="RoleResponsibilties"
            fieldId="RoleResponsibiltiesField"
            isRequired={1}
            errId="RoleResponsibiltiesError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="RoleResponsibilties"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="Part-time/Full-time"
              labelStyle={{ color: '#6B7280' }}
              options={["Full Time", "Part Time", "Contractual", "Freelance", "Third-Party", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
          <ABTextEdu
            label="Reason for leaving"
            name="ReasonForLeaving"
            id="ReasonForLeaving"
            fieldId="ReasonForLeavingField"
            isRequired={1}
            errId="ReasonForLeavingError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="ReasonForLeaving"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="State of Employment"
              labelStyle={{ color: '#6B7280' }}
              options={["Full Time", "Part Time", "Contractual", "Freelance", "Third-Party", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
        </div>
      </div>

      <div className="kycDetails border-bottom my-3">
        <h1 className='tabsContentHead pt-3'>Other Details</h1>
        <div className="row">
          <ABTextEdu
            label="Employee Code"
            name="EmployeeCode"
            id="EmployeeCode"
            fieldId="EmployeeCodeField"
            isRequired={1}
            errId="EmployeeCodeError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="EmployeeCode"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Grade Band"
            name="GradeBand"
            id="GradeBand"
            fieldId="GradeBandField"
            isRequired={1}
            errId="GradeBandError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="GradeBand"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="UAN"
            name="UAN"
            id="UAN"
            fieldId="UANField"
            isRequired={1}
            errId="UANError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="UAN"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <p className="col-12">When can you submit reliving letter</p>
          <EMPDate
            placeholder="Select Date"
            name="SelectDate"
            id="SelectDate"
            fieldId="SelectDateField"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="company_date_joining"
            errId="SelectDateError"
            isRequired={1}
            saveDate={saveDateHandler}
            isDisabled={allDisabled}
            checkID={58} // Example checkID, adjust according to your logic
            minDateDOL={null}
            maxDOJDate={null}
            divClass="col-lg-4 col-md-6 col-sm-12"
            placeholderStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Role & Responsibilties"
            name="RoleResponsibilties"
            id="RoleResponsibilties"
            fieldId="RoleResponsibiltiesField"
            isRequired={1}
            errId="RoleResponsibiltiesError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="RoleResponsibilties"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="Part-time/Full-time"
              labelStyle={{ color: '#6B7280' }}
              options={["Full Time", "Part Time", "Contractual", "Freelance", "Third-Party", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
          <ABTextEdu
            label="Reason for leaving"
            name="ReasonForLeaving"
            id="ReasonForLeaving"
            fieldId="ReasonForLeavingField"
            isRequired={1}
            errId="ReasonForLeavingError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="ReasonForLeaving"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="State of Employment"
              labelStyle={{ color: '#6B7280' }}
              options={["Full Time", "Part Time", "Contractual", "Freelance", "Third-Party", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
        </div>
      </div>

      <div className="international-worker border-bottom my-3">
        <h1 className='tabsContentHead pt-3'>Reporting Manager Detail</h1>
        <p className="col-12">Can we contact him/her for reference check?</p>
        <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChange} />

        {isContactRM && (
          <div className='row'>
            <ABTextEdu
              label="Contact Person Name"
              name="ContactPersonName"
              id="ContactPersonName"
              fieldId="ContactPersonNameField"
              isRequired={1}
              errId="ContactPersonNameError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="ContactPersonName"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
            <ABTextEdu
              label="Designation"
              name="Designation"
              id="Designation"
              fieldId="DesignationField"
              isRequired={1}
              errId="DesignationError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="Designation"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
            <ABTextEdu
              label="Email Address"
              name="EmailAddress"
              id="EmailAddress"
              fieldId="EmailAddressField"
              isRequired={1}
              errId="EmailAddressError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="EmailAddress"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
            <ABTextEdu
              label="Mobile Number"
              name="MobileNumber"
              id="MobileNumber"
              fieldId="MobileNumberField"
              isRequired={1}
              errId="MobileNumberError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="MobileNumber"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
          </div>
        )}
      </div>

    </div>
  );
};

export default Emp1;
